// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import TaxiCard from "./TaxiCard";
import Timer from "../core/components/Timer";
import FitTextToBounds from "../core/components/FitTextToBounds";
/* START-USER-IMPORTS */
import { GameDataHandler } from '../GameDataHandler';
import { CharacterNameValues } from '../Character';

/* END-USER-IMPORTS */

export default class Scoreboard extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 182, y ?? 59.5);

    // taxiCard
    const taxiCard = new TaxiCard(scene, 244, 0);
    taxiCard.scaleX = 0.6;
    taxiCard.scaleY = 0.6;
    taxiCard.angle = -5;
    this.add(taxiCard);

    // holder_score_png
    const holder_score_png = scene.add.image(0, 0, "common", "holder-small-center.png");
    this.add(holder_score_png);

    // score
    const score = scene.add.text(-98, -4, "", {});
    score.setOrigin(0, 0.5);
    score.text = "0";
    score.setStyle({ "align": "center", "fixedWidth":90,"fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "38px" });
    this.add(score);

    // time
    const time = scene.add.text(15, -4, "", {});
    time.setOrigin(0, 0.5);
    time.text = "00:00";
    time.setStyle({ "align": "center", "fixedWidth":140,"fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "38px" });
    this.add(time);

    // scoreIcon
    const scoreIcon = scene.add.image(-124, -6, "common", "icon-note-pile.png");
    scoreIcon.scaleX = 0.45;
    scoreIcon.scaleY = 0.45;
    this.add(scoreIcon);

    // fareText
    const fareText = scene.add.text(-77, -32, "", {});
    fareText.setOrigin(0.5, 0.5);
    fareText.visible = false;
    fareText.text = "Fare";
    fareText.setStyle({ "color": "#000", "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "38px" });
    this.add(fareText);

    // timeText
    const timeText = scene.add.text(86, -32, "", {});
    timeText.setOrigin(0.5, 0.5);
    timeText.visible = false;
    timeText.text = "Time";
    timeText.setStyle({ "color": "#000", "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "38px" });
    this.add(timeText);

    // time (components)
    new Timer(time);

    // fareText (components)
    const fareTextFitTextToBounds = new FitTextToBounds(fareText);
    fareTextFitTextToBounds.maxWidth = 140;
    fareTextFitTextToBounds.maxHeight = 38;
    fareTextFitTextToBounds.minFontSize = 20;
    fareTextFitTextToBounds.constrainByWidth = true;
    fareTextFitTextToBounds.constrainByHeight = true;

    // timeText (components)
    const timeTextFitTextToBounds = new FitTextToBounds(timeText);
    timeTextFitTextToBounds.maxWidth = 140;
    timeTextFitTextToBounds.maxHeight = 38;
    timeTextFitTextToBounds.minFontSize = 20;
    timeTextFitTextToBounds.constrainByWidth = true;
    timeTextFitTextToBounds.constrainByHeight = true;

    this.taxiCard = taxiCard;
    this.score = score;
    this.time = time;
    this.fareText = fareText;
    this.timeText = timeText;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    this.on(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.registry.events.off(GameDataHandler.events.ChangeScore, this.onScoreChange, this);
      // this.scene.registry.events.off(GameDataHandler.events.ChangeDistance, this.onDistanceChange, this);
    });
    this.scene.registry.events.on(GameDataHandler.events.ChangeScore, this.onScoreChange, this);
    // this.scene.registry.events.on(GameDataHandler.events.ChangeDistance, this.onDistanceChange, this);
    /* END-USER-CTR-CODE */
  }

  private taxiCard: TaxiCard;
  private score: Phaser.GameObjects.Text;
  private time: Phaser.GameObjects.Text;
  private fareText: Phaser.GameObjects.Text;
  private timeText: Phaser.GameObjects.Text;

  /* START-USER-CODE */
  protected taxiStartX: number = 0;
  protected taxiStartY: number = 0;
  protected taxiStartRot: number = 0;
  protected taxiStartScale: number = 0;

  public getTimer(): Timer {
    return Timer.getComponent(this.time);
  }

  public setCharacter(scoreboardCharacter: CharacterNameValues) {
    this.taxiCard.changeOwner(scoreboardCharacter);
  }

  protected awake() {
    this.alpha = 0;
    this.hideCard();
  }

  public showScoreboard() {
    this.setVisible(true);
    this.alpha = 0;

    this.scene.add.tween({
      targets: this,
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
    this.hideCard();
  }

  public hideScoreboard() {
    this.scene.add.tween({
      targets: this,
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => this.setVisible(false)
    });
  }

  public showTaxiCard() {
    this.taxiCard.alpha = 1;
    this.scene.add.tween({
      targets: this.taxiCard,
      scale: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Bounce.Out
    });
    this.scene.add.tween({
      targets: this.taxiCard,
      x: this.taxiStartX,
      y: this.taxiStartY,
      scale: this.taxiStartScale,
      angle: this.taxiStartRot,
      duration: 500,
      delay: 1000,
      ease: Phaser.Math.Easing.Cubic.InOut
    });
  }

  protected hideCard() {
    this.taxiStartX = this.taxiCard.x;
    this.taxiStartY = this.taxiCard.y;
    this.taxiStartRot = this.taxiCard.angle;
    this.taxiStartScale = this.taxiCard.scale;
    this.taxiCard.x = 0;
    this.taxiCard.y = 300;
    this.taxiCard.angle = 0;
    this.taxiCard.scale = 0;
    this.taxiCard.alpha = 0;
  }

  protected onScoreChange(parent: any, value: any, previousValue: any) {
    this.score.text = Math.trunc(value).toString();
  }

  // protected onDistanceChange(parent: any, value: any, previousValue: any) {
  //   this.distance.text = Math.trunc(value / 100).toString();
  // }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
